export const slugifyText = (value: string) =>
  String(value || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .replace(/-{2,}/g, "-");

export const buildCasePath = (
  caseIndex: number | string,
  title: string,
  briefingTitle?: string
) => {
  const slugSource =
    String(briefingTitle || "").trim() || String(title || "").trim() || `case-${caseIndex}`;
  const slug = slugifyText(slugSource) || `case-${caseIndex}`;
  return `/agency/cases/${caseIndex}/${slug}`;
};
